<template>
  <div class="p-trainzcu">
    <section class="c-p-r support-top">
      <div class="c-d-f c-fd-c c-ai-c cm-width c-p-c c-ta-c">
        <p class="c-fs-38 c-c-text-color c-mb-32 c-fw-b top-title">ZABBIX 初级认证培训(ZCU)</p>
        <p class="c-c-text-color c-ff-l c-fs-16 top-desc">适用学习Zabbix的基本使用，了解Zabbix的功能，使用Zabbix前端查看和监控管理信息</p>
      </div>
    </section>
    <section class="support-wrap">
      <section class="c-visible-pc" v-if="$store.state.isPc">
        <section class="cm-width">
          <div class="c-d-f c-ai-c c-mt-80 c-mb-40">
            <img src="../../assets/index/icon.png">
            <span class="c-ml-12 c-c-text-color c-ff-m c-fs-24">课程信息</span>
          </div>
          <table class="c-fs-14 table-course-info">
            <tr>
              <td class="c-pl-24" style="width: 15%;">版本</td>
              <td style="width: 20%">规模</td>
              <td style="width: 30%">参加要求</td>
              <td style="width: 15%">时长</td>
              <td style="width: 15%">培训费</td>
            </tr>
            <tr class="c-c-text-grey">
              <td class="c-pl-24">Zabbix 5.0</td>
              <td>小班课程（50人以内）</td>
              <td>无</td>
              <td>1天</td>
              <td>¥ 2,500</td>
            </tr>
          </table>
          <div class="c-d-f c-jc-fe c-mt-28 c-ff-b">
            <button class="c-btn-156" disabled>无</button>
            <button class="c-ml-12 c-btn-dark-156-nob" @click="$router.push('/train_zcs')">下一个等级</button>
          </div>
        </section>
      </section>
      <section class="c-visible-mobile" v-if="!$store.state.isPc">
        <section class="cm-width">
          <div class="c-d-f c-ai-c c-mt-40 c-mb-24">
            <img src="../../assets/index/icon.png" class="c-icon-mobile">
            <span class="c-ml-8 c-c-text-color c-ff-m c-fs-16">课程信息</span>
          </div>
          <div class="c-o-s">
            <table class="c-fs-12 table-course-info-mobile">
              <tr>
                <td class="c-pl-12" style="width: 15%;">版本</td>
                <td style="width: 20%">规模</td>
                <td style="width: 30%">参加要求</td>
                <td style="width: 15%">时长</td>
                <td style="width: 15%">培训费</td>
              </tr>
              <tr class="c-c-text-grey">
                <td class="c-pl-12">Zabbix 5.0</td>
                <td>小班课程（50人以内）</td>
                <td>无</td>
                <td>1天</td>
                <td>¥ 2,500</td>
              </tr>
            </table>
          </div>
          <div class="c-d-f c-jc-c c-mt-24 c-ff-b">
            <button class="c-btn-156" disabled>无</button>
            <button class="c-ml-12 c-btn-dark-156-nob" @click="$router.push('/train_zcs')">下一个等级</button>
          </div>
        </section>
      </section>
      <section class="c-visible-pc" v-if="$store.state.isPc">
        <section class="cm-width">
          <div class="c-d-f c-ai-c c-mt-80 c-mb-40">
            <img src="../../assets/index/icon.png">
            <span class="c-ml-12 c-c-text-color c-ff-m c-fs-24">课程总览</span>
          </div>
          <table class="c-fs-14 c-c-text-grey table-course-overview">
            <tr>
              <td rowspan="12" class="c-ta-c" center style="background: #EFF3FC; color: #142B83; font-size: 22px; width: 223px;">Day1</td>
            </tr>
            <tr v-for="(item, index) in zcuList" :key="index">
              <td class="c-pl-24" style="width: 40%;">{{item.left}}</td>
              <td class="c-pl-24" style="width: 40%;">{{item.right}}</td>
            </tr>
          </table>
        </section>
      </section>
      <section class="c-visible-mobile" v-if="!$store.state.isPc">
        <section class="cm-width">
          <div class="c-d-f c-ai-c c-mt-40 c-mb-24">
            <img src="../../assets/index/icon.png" class="c-icon-mobile">
            <span class="c-ml-8 c-c-text-color c-ff-m c-fs-16">课程总览</span>
          </div>
          <div class="c-o-s c-fs-12">
            <table class="c-c-text-grey table-course-overview-mobile">
              <tr>
                <td rowspan="8" class="c-ta-c" center style="background: #EFF3FC; color: #142B83; font-size: 14px; width: 111px;">Day1</td>
              </tr>
              <tr v-for="(item, index) in zcuList" :key="index">
                <td class="c-pl-12" style="width: 30%;">{{item.left}}</td>
                <td class="c-pl-12" style="width: 30%;">{{item.right}}</td>
              </tr>
            </table>
          </div>
        </section>
      </section>
      <section class="c-d-f c-mt-80 c-p-r apply-train">
        <div class="c-p-c cm-width">
          <div class="c-d-f c-jc-c c-ff-b">
            <button class="c-btn-dark-156">查看培训行程</button>
            <button class="c-ml-12 c-btn-156-nob">申请培训</button>
          </div>
        </div>
      </section>
      <section class="c-visible-pc" v-if="$store.state.isPc">
        <section class="cm-width">
          <div class="c-d-f c-ai-c c-mt-80 c-mb-40">
            <img src="../../assets/index/icon.png">
            <span class="c-ml-12 c-c-text-color c-ff-m c-fs-24">认证证书</span>
          </div>
          <div class="c-d-f c-jc-sb">
            <img class="c-bc-white c-cs-p certificate-item" src="../../assets/training/certificate1.jpg" preview="certificate-pc"/>
            <img class="c-bc-white c-cs-p certificate-item" src="../../assets/training/certificate1.jpg" preview="certificate-pc"/>
            <img class="c-bc-white c-cs-p certificate-item" src="../../assets/training/certificate1.jpg" preview="certificate-pc"/>
          </div>
        </section>
      </section>
      <section class="c-visible-mobile" v-if="!$store.state.isPc">
        <section class="cm-width">
          <div class="c-d-f c-ai-c c-mt-40 c-mb-24">
            <img src="../../assets/index/icon.png" class="c-icon-mobile">
            <span class="c-ml-8 c-c-text-color c-ff-m c-fs-16">认证证书</span>
          </div>
          <div class="c-d-f c-jc-sb">
            <img class="c-bc-white certificate-item" src="../../assets/training/certificate1.jpg" preview="certificate-mobile"/>
            <img class="c-bc-white certificate-item" src="../../assets/training/certificate1.jpg" preview="certificate-mobile"/>
            <img class="c-bc-white certificate-item" src="../../assets/training/certificate1.jpg" preview="certificate-mobile"/>
          </div>
        </section>
      </section>
      <section class="c-d-f c-mt-128 c-p-r contact">
        <div class="c-p-c cm-width">
          <div class="c-d-f c-fd-c c-ai-c c-ff-b">
            <p class="c-fs-24 c-mb-32 c-c-text-color contact-title">想了解更多产品和服务信息？</p>
            <button class="c-btn-dark-124" @click="toUrl('/about')">联系我们</button>
          </div>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
import { zcuList } from '../../constants/train.constant'
export default {
  name: 'trainzcu',
  data () {
    return {
      zcuList: zcuList
    }
  },
  methods: {
    toUrl (url) {
      this.$router.push(url)
    }
  },
  created () {
  }
}
</script>

<style lang="scss">
.p-trainzcu {
  min-height: calc(100vh - 90px - 525px);
  .support-top {
    height: 560px;
    background: url("../../assets/training/training-top.jpg") no-repeat;
    background-size: cover;
    @media screen and (max-width: $max-width-standard) {
      height: 232px;
      .top-title {
        font-size: 19px;
        margin-bottom: 12px;
      }
      .top-desc {
        width: 70%;
        font-size: 9px;
        line-height: 16px;
        margin-bottom: 15px;
      }
    }
  }
  .support-wrap {
    margin: 0 auto;
    .table-course-info, .table-course-overview {
      width: 100%;
      border-collapse: collapse;
      tr {
        border-top: 1px solid #B5C4E8;
        border-bottom: 1px solid #B5C4E8;
        background: white;
        td {
          height: 54px;
        }
      }
    }
    .table-course-info {
      & tr:nth-child(1) {
        color: #142B83;
        background: #EFF3FC;
      }
    }
    .table-course-overview {
      & tr:nth-child(even) {
        background: #FAFAFA;
      }
    }
    .table-course-info-mobile, .table-course-overview-mobile {
      width: 800px;
      border-collapse: collapse;
      tr {
        border-top: 1px solid #B5C4E8;
        border-bottom: 1px solid #B5C4E8;
        background: white;
        td {
          height: 40px;
        }
      }
    }
    .table-course-info-mobile {
      & tr:nth-child(1) {
        color: #142B83;
        background: #EFF3FC;
      }
    }
    .table-course-overview-mobile {
      & tr:nth-child(even) {
        background: #FAFAFA;
      }
    }
    .apply-train {
      height: 280px;
      @media screen and (max-width: $max-width-standard) {
        height: 192px;
        margin-top: 40px;
      }
      background: url("../../assets/training/training-blue.png") no-repeat;
      background-size: cover;
    }
    .contact {
      height: 280px;
      @media screen and (max-width: $max-width-standard) {
        height: 192px;
        margin-top: 24px;
        .contact-title {
          font-size: 19px;
          margin-bottom: 15px;
        }
      }
      background: url("../../assets/training/training-grey.png") no-repeat;
      background-size: cover;
    }
    .certificate-item {
      height: 283px;
      width: calc(100% / 3 - 12px);
      @media screen and (max-width: $max-width-standard) {
        height: 80px;
        width: calc(100% / 3 - 6px);
      }
      box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
    }
  }
}
</style>
